module.exports = __webpack_public_path__ + "img/logo.6389f13e.png";